import {Component, Injector, EventEmitter, Output} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';
import { SocketService } from '../../services/socket.service';

@Component({
    template: `
    <div class="user-popover-outline">
        <div class="user-popover">
            <div class="bar-header">
                <h1 class="title ly_pop_title">결투방 생성</h1>
                <a class="ly_pop_close" (click)="closePopover()"><mat-icon class="mat-icon-30 btn_close" svgIcon="xi-close"></mat-icon></a>
            </div>
            <!-- 방만들기 -->

            <form name="popupForm" class="popupForm" #popupForm="ngForm">
                <div class="pop-body">
                    <div class="fight_make">
                        <ul>
                            <li>
                                <div *ngIf="!game_type" class="select_group" style="margin-top: 0;">
                                    <mat-select name="game_type" placeholder="게임타입 선택" [(ngModel)]="game_type" required (selectionChange)="setPickLists(game_type)" style="width: 100%;">
                                        <mat-option *ngFor="let gametype of tmp_game_type | objtoarray" [value]="gametype.k">{{ gametype.v }}</mat-option>
                                    </mat-select>

                                </div>
                                <div *ngIf="game_type!=''" class="bt_sel">
                                    <mat-radio-group name="pick_type" [(ngModel)]="setData.input.pick_type" required class="layout-row">
                                        <mat-radio-button class="mat-radio" *ngFor="let obj of setData.setpicklist" [value]="obj.value">{{obj.text}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>

                                <div class="select_group">
                                    <mat-select name="betting_no" placeholder="베팅회차 선택" [(ngModel)]="setData.input.betting_no" required style="width: 100%;">
                                        <mat-option *ngFor="let betround of setData.betround" [value]="betround.key">{{ betround.value }}</mat-option>
                                    </mat-select>

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

            </form>
            <div class="pop-footer">
                <button mat-button (click)="createRoom()" [disabled]="!popupForm.form.valid"><span style="color: #fff;">생성</span></button>
            </div>
        </div>
    </div><!-- .user-popover-outline -->
    `,
    styleUrls: ['style.scss']
})

export class LayerPopFightCreateComponent {
    @Output() popclosed = new EventEmitter();

    setData = {setpicklist: [], betround: null, input: {betting_point: 0, pick_type: '', betting_no: null}};
    tmp_game_type: any;
    game_type: string;
    pick: string;
    constructor(private injector: Injector, private socketService: SocketService, private http: HttpService, protected toasterService: ToasterService) { // private :
    //    this.pick = this.injector.get('pick');
        const paramObj = this.injector.get('paramObj');

        this.pick = paramObj.pick;
        this.set_game_type();
        this.refresh_betround();
    }

    /**
     * 템플릿을 초기화 한다.
     * @param Object obj {pick: pick, game_type: game_type}
     */
    set_game_type() {
        // 템플릿 폼 가져오기
        switch (this.pick) {
            case 'ladder':
            case 'dari':
            case 'powerLadder':
                this.tmp_game_type = {START: '출발', LINE: '줄수', ODDEVEN: '홀짝'}; // 게임타입이 없는 경우(전체에서 선택시)에 출력용
                switch (this.game_type) {
                    case 'START': // 출발
                        this.setData.setpicklist = [{value: 'LEFT', text: '좌'}, {value: 'RIGHT', text: '우'}];
                        break;
                    case 'LINE': // 줄수
                        this.setData.setpicklist = [{value: 'SHAPE3', text: '3줄'}, {value: 'SHAPE4', text: '4줄'}];
                        break;
                    case 'ODDEVEN': // 홀짝
                        this.setData.setpicklist = [{value: 'ODD', text: '홀'}, {value: 'EVEN', text: '짝'}];
                        break;
                    case 'ALLKILL':
                        break;
                }
                break;
            case 'powerball':
                this.tmp_game_type = {PODDEVEN: '(파)홀짝', PLOWHIGH: '(파)언오버', NODDEVEN: '(일)홀짝', NLOWHIGH: '(일)언오버'}; // 게임타입이 없는 경우(전체에서 선택시)에 출력용
                switch (this.game_type) {
                    case 'PODDEVEN': // 홀짝
                        this.setData.setpicklist = [{value: 'ODD', text: '홀'}, {value: 'EVEN', text: '짝'}];
                        break;
                    case 'PLOWHIGH': // 언오버
                        this.setData.setpicklist = [{value: 'LOW', text: '언더'}, {value: 'HIGH', text: '오버'}];
                        break;
                    case 'NODDEVEN': // 홀짝
                        this.setData.setpicklist = [{value: 'ODD', text: '홀'}, {value: 'EVEN', text: '짝'}];
                        break;
                    case 'NLOWHIGH': // 언오버
                        this.setData.setpicklist = [{value: 'LOW', text: '언더'}, {value: 'HIGH', text: '오버'}];
                        break;
                    // case 'NSCALE': // 대중소
                    //    this.setData.setpicklist    = [{'value': 'ODD', 'text': '홀'}, {'value': 'EVEN', 'text': '짝'}];
                    // break;
                }
                break;
        }
    } // let set_game_type    = function() {

    /**
     * 결투방 생성하기
     */
    createRoom() {
        const params = {pick: this.pick,
                        game_type: this.game_type,
                        pick_type: this.setData.input.pick_type,
                        betting_no: this.setData.input.betting_no};
        this.http.post({url: 'battle/create-battle', params: params}).then((obj) => {
            if (obj.result === true) {
                this.socketService.Emit('add_battle_list', {id: obj.id} ); //
                this.closePopover();
            } else {
                this.toasterService.showToaster('error', obj.message);
            }
        });

    }

    // 게임타입이 없는 경우 수동으로 게임타입을 선택하는 경우 디스플레이
    setPickLists(game_type) {
        this.game_type = game_type;
        this.set_game_type();
    }

    // betting round 정보를 리프레쉬한다.
    refresh_betround() {
        // 베팅회차 정보 가져오기
        const params = {pick: this.pick};
        this.http.get({url: 'battle/get-round', params: params}).then((obj) => {
            this.setData.betround = obj.data;
        });
    }

    closePopover() {
        this.popclosed.emit();
    }
}
